<template>
	<div class="c-main-nav" role="navigation" @mouseleave="handleMouseLeave()">
		<div class="o-width-limiter">
			<span class="t-visually-hidden">Huvudnavigering</span>
			<ul class="c-main-nav__list">
				<li class="c-main-nav__item"
					v-for="(link, index) in links" :key="index"
					:class="{'c-main-nav__item--selected': link.selected}"
					@mouseover="handleMouseOver(index)"
					@keydown.32="triggerSpace($event, index)"
					@keydown.38="triggerKeyPress($event, index)"
					@keydown.40="triggerKeyPress($event, index)"
					@keyup="triggerKeyPress($event, index)"
					:aria-controls="'content-' + index"
					:aria-expanded="$resize && $mq.above(1025) && currentSubLevelIndex === index ? true : false">
					<a
						:id="'item-' + index"
						:href="link.url"
						class="c-main-nav__link">
						<v-icon :name="'icon-' + link.icon" size="m" css-modifiers="c-main-nav__icon"></v-icon>
						<div class="c-main-nav__link-body">
							<span class="c-main-nav__title">{{link.name}}</span>
							<small class="c-main-nav__label">{{link.subname}}</small>
						</div>
					</a>
					<div
						:class="(currentSubLevelIndex === index) ? 'c-main-nav__content c-main-nav__content--show' : 'c-main-nav__content'"
						:id="'content-' + index"
						v-if="$resize && $mq.above(1025)"
						:aria-expanded="$resize && $mq.above(1025) && currentSubLevelIndex === index ? true : false"
						:aria-hidden="$resize && $mq.above(1025) && currentSubLevelIndex === index ? false : true"
						:aria-labelledby="'item-' + index"
						role="group">
						<div class="o-width-limiter">
							<span class="t-visually-hidden">Subnavigering</span>
							<div class="c-main-nav__content-wrapper">
								<div class="c-main-nav__content-left">
									<ul class="c-main-nav__content-list">
										<li
											v-for="(page, i) in link.pages"
											:key="i"
											class="c-main-nav__content-item"
											:class="{'selected': page.selected}">
											<a
											:href="page.url"
											class="c-main-nav__content-link">
												<v-icon :name="'icon-' + page.icon" size="m" css-modifiers="c-main-nav__icon"></v-icon>
												<div class="c-main-nav__link-body">
													<span class="c-main-nav__title">{{page.name}}</span>
													<small class="c-main-nav__label">{{page.subname}}</small>
												</div>
											</a>
										</li>
									</ul>
									<v-main-nav-faq v-if="link.faq.position === 'bottom'" :faq="link.faq"></v-main-nav-faq>
								</div>
								<div class="c-main-nav__content-right">
									<v-main-nav-contact v-if="link.contact" :contact="link.contact"></v-main-nav-contact>
									<v-main-nav-faq v-if="link.faq.position === 'right'" :faq="link.faq"></v-main-nav-faq>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import VIcon from '../../../components/icon/VIcon.vue';
import VMainNavFaq from './VMainNavFaq.vue';
import VMainNavContact from './VMainNavContact.vue';

export default {
	name: 'VMainNav',
	components: {
		VIcon,
		VMainNavFaq,
		VMainNavContact
	},
	props: {
		links: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			currentSubLevelIndex: ''
		}
	},
	methods: {
		handleMouseOver(index) {
			this.currentSubLevelIndex = index;
		},
		handleMouseLeave() {
			this.currentSubLevelIndex = '';
		},
		linkBlur(index, length) {
			if (index + 1 === length) this.handleMouseLeave();
		},
		triggerSpace(event, index) {
			event.preventDefault();
			this.handleMouseOver(index);
		},
		triggerKeyPress(event, index) {
			if (event.keyCode === 40) { /* Arrow down */
				event.preventDefault();
				this.handleMouseOver(index);
			} else if (event.keyCode === 27 || event.keyCode === 38) { /* Escape, Arrow up */
				event.preventDefault();
				this.handleMouseLeave();
			} else if (event.keyCode === 9 && event.target && this.currentSubLevelIndex !== '' && this.currentSubLevelIndex !== index) { /* Tab (close megamenu when tabbing to other menuitem) */
				this.handleMouseLeave();
			}
		}
	}
}
</script>
